import React, { useState } from 'react';
import { articlesList } from './articles'; // Your existing articles list
import { AesEncrypt , AesDecrypt } from '../../../services/crypto';   // Your existing crypto
import Modal from 'react-modal';
import './MobPeriod-push.css';       // Import the separate CSS
import WebService from "../../../services/webservice";
import axios from 'axios';
Modal.setAppElement('#root');

const API_BASE = '/api'; // Adjust if no proxy (e.g., 'http://localhost:5000/api')

const MobPushArticles = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentArticle, setCurrentArticle] = useState({ title: '', htmlContent: '' });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

const handleStoreToDB = async (letter, title) => {
  setLoading(true);
  setMessage("");

  try {
    // 1️⃣ First get article content
    const viewPayload = {
      letter,
      language: "english",
    };

    const viewEnc = AesEncrypt(viewPayload);

    const viewResponse = await axios.post(
      `${WebService}api/getReproductionContent`,                       // get-reproduction-content
      { EncData: viewEnc }
    );

    if (viewResponse?.data?.response !== "S") {
      setMessage("❌ Failed to fetch article content");
      return;
    }

    const { title: fetchedTitle, htmlContent } = viewResponse.data;

    // 2️⃣ Now save to DB
    const savePayload = {
      letter,
      language: "english",
      title: fetchedTitle,
      htmlContent, // ✅ NON-empty
    };

    const saveEnc = AesEncrypt(savePayload);

    const saveResponse = await axios.post(
      `${WebService}api/save-single-article`,
      { EncData: saveEnc }
    );

    if (saveResponse?.data?.response === "S") {
      setMessage(`✅ ${letter} - Saved successfully!`);
    } else {
      setMessage(`❌ ${saveResponse?.data?.message || "Save failed"}`);
    }
  } catch (error) {
    console.error("Save error:", error);
    setMessage("❌ Network / Server error");
  } finally {
    setLoading(false);
  }
};


  // const handleView = async (letter) => {
  //   setLoading(true);
  //   setMessage('');

  //   const payload = { letter, language: 'english' };
  //   const encrypted = AesEncrypt(payload);

  //   try {
  //     const res = await fetch(`${API_BASE}/get-reproduction-content`, {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ EncData: encrypted }),
  //     });
  //     const data = await res.json();

  //     if (data.response === 'S') {
  //       setCurrentArticle({ title: data.title, htmlContent: data.htmlContent });
  //       setModalIsOpen(true);
  //     } else {
  //       setMessage(`❌ ${data.message || 'Article not found'}`);
  //     }
  //   } catch (err) {
  //     setMessage('❌ Failed to load article');
  //   }
  //   setLoading(false);
  // };


const handleView = async (letter) => {
  setLoading(true);
  setMessage("");

  try {
    const payload = {
      letter,
      language: "english",
    };

    const encryptedData = AesEncrypt(payload);

    const response = await axios.post(
      `${WebService}api/get-reproduction-content`,
      { EncData: encryptedData }
    );

    if (response?.data?.response === "S") {
      // ✅ DIRECTLY USE RESPONSE (NO DECRYPT)
      setCurrentArticle({
        title: response.data.title || "",
        htmlContent: response.data.htmlContent || "",
      });
      setModalIsOpen(true);
    } else {
      setMessage(`❌ ${response?.data?.message || "Article not found"}`);
    }
  } catch (error) {
    console.error("View error:", error);
    setMessage("❌ Failed to load article");
  } finally {
    setLoading(false);
  }
};



  // const handleSeedAll = async () => {
  //   if (!window.confirm('⚠️ This will DELETE all existing articles and re-insert the 10 default ones. Continue?')) {
  //     return;
  //   }
  //   setLoading(true);
  //   try {
  //     const res = await fetch(`${API_BASE}/reproduction-articles`, { method: 'POST' });
  //     const data = await res.json();
  //     setMessage(data.response === 'S' ? '✅ All 10 articles seeded!' : `❌ ${data.message}`);
  //   } catch (err) {
  //     setMessage('❌ Seeding failed');
  //   }
  //   setLoading(false);
  // };


  const handleSeedAll = async () => {
  if (
    !window.confirm(
      "⚠️ This will DELETE all existing articles and re-insert the 10 default ones. Continue?"
    )
  ) {
    return;
  }

  setLoading(true);
  setMessage("");

  try {
    const response = await axios.post(
      `${WebService}api/reproduction-articles`
    );

    if (response?.data?.response === "S") {
      setMessage("✅ All 10 articles seeded!");
    } else {
      setMessage(`❌ ${response?.data?.message || "Seeding failed"}`);
    }
  } catch (error) {
    console.error("Seed error:", error);
    setMessage("❌ Seeding failed");
  } finally {
    setLoading(false);
  }
};
 
  return (
    <div className="articles-container">
      <h1 className="page-title">Sexual Health & Reproduction Articles</h1>
      <p className="page-subtitle">Admin Management Panel</p>

      <div className="seed-button-container">
        <button onClick={handleSeedAll} disabled={loading} className="seed-button">
          {loading ? 'Seeding...' : '🌱 Seed All 10 Articles to DB (Clear & Insert)'}
        </button>
      </div>

      {message && (
        <div className={`message ${message.includes('✅') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}

      <div className="articles-grid">
        {articlesList.map((article) => (
          <div key={article.letter} className="article-card">
            <div className="card-header">
              <h3>{article.letter}</h3>
            </div>
            <div className="card-body">
              <p className="card-title">{article.title}</p>
              <div className="card-buttons">
                <button
                  onClick={() => handleStoreToDB(article.letter, article.title)}
                  disabled={loading}
                  className="btn btn-store"
                >
                  💾 Store to DB
                </button>
                <button
                  onClick={() => handleView(article.letter)}
                  disabled={loading}
                  className="btn btn-view"
                >
                  👁️ View
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal for Viewing Article */}
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
        className="article-modal"
        overlayClassName="modal-overlay"
      >
        <div className="modal-header">
          <h2>{currentArticle.title}</h2>
          <button onClick={() => setModalIsOpen(false)} className="close-btn">
            ×
          </button>
        </div>
        <div
          className="modal-content"
          dangerouslySetInnerHTML={{ __html: currentArticle.htmlContent }}
        />
      </Modal>
    </div>
  );
};

export default MobPushArticles;